module.exports = __webpack_public_path__ + "static/media/RP_belair.eb67af1e.jpg";